import { render } from "./checkGroup.vue?vue&type=template&id=b4079d68"
import script from "./checkGroup.vue?vue&type=script&lang=js"
export * from "./checkGroup.vue?vue&type=script&lang=js"

import exportComponent from "D:\\test\\newDemo\\alp-ui\\vue-component\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__